<!-- ─── Hero Row ─────────────────────────────────────────────── -->
<div class="hero-row">
  <div class="hero-text">
    <div class="title">
      {{ "Generate Resume" | translate }}
    </div>
    <div class="description">
      {{ "Build your brand-new resume in as little as 5 minutes" | translate }}
    </div>
    <div class="mt-3">
      <button class="gradient-button" (click)="goToGenerateResume()">
        {{ "Get Started Now" | translate }}
      </button>
      <p class="service-detail" [innerHTML]="'SERVICE_DETAIL.TEXT' | translate"></p>
    </div>
  </div>

  <div class="hero-image">
    <img src="../../../assets/img/generate-resume.png" alt="Generate Resume" />
  </div>
</div>
<app-video-tutorial
  [title]="'generateResume.videoTitle'"
  [buttonText]="'generateResume.videoButton'"
  (buttonClicked)="goToGenerateResume()"
  [videoPath]="'assets/video/Generate Cv.mp4'"
  [videoPoster]="'assets/img/generate-resume.png'"
  [features]="[
    'generateResume.feature1',
    'generateResume.feature2',
    'generateResume.feature3'
  ]">
</app-video-tutorial>
<!-- ─── Services Section ──────────────────────────────────────── -->
<section class="services-section">
  <div class="container">
    <div class="row justify-content-center">

      <!-- Title Card -->
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "The Professional Resume Maker and CV Builder" | translate }}
          </h3>
          <p class="services-main-description">
            {{ "Up-Career is everything you need to create an online resume and make your next career move" | translate
            }}
          </p>
        </div>
      </div>

      <!-- Service Cards -->
      <app-card *ngFor="let item of services" [color]="item.color" [img]="item.img" [title]="item.title"
        [description]="item.description" />
    </div>
  </div>
</section>

<!-- ─── CV Section ────────────────────────────────────────────── -->
<section class="cv-section">
  <div class="container">

    <!-- Unified section title — same class used on every section -->
    <div class="text-center">
      <h3 class="titlle">{{ 'CV_SECTION.TITLE' | translate }}</h3>
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-4">
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="assets/img/Frame_2095587930-removebg-preview.png" alt="CV Image" />
      </div>

      <div class="col-12 col-md-7 px-md-5">
        <p class="section-text">{{ 'CV_SECTION.DESCRIPTION' | translate }}</p>
        <button class="gradient-button" routerLink="/create-cover-letter">
          {{ 'CV_SECTION.BUTTON' | translate }}
        </button>
      </div>
    </div>

  </div>
</section>